<template>
  <div class="contact-section" ref="self">
      <img :src="images.contact" @load="emitReady">
      <a class="phone" href="tel:862128905288"></a>
      <a class="email" href="mailto:fmba@ceibs.edu"></a>
  </div>
</template>

<script>
import images from '@/utils/images.js'
import active from './active.js'
export default {
    name: 'Contact',
    mixins: [active],
    data () {
        return {
            images: images,
            index: 6
        }
    }
}
</script>

<style lang="scss" scoped>
    .contact-section {
        position: relative;
        .phone, .email {
            text-decoration: none;
            display: block;
            position: absolute;
            left: 212px;
            width: 304px;
            height: 48px;
        }
        .phone {
            top: 422px;
        }

        .email {
            top: 470px;
        }
    }
</style>